// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"17a06d43","431":"3f8722ee"}[chunkId] + ".chunk.js";
};